import React, { useEffect, useState } from "react";
import {
  Table,
  Select,
  DatePicker,
  Button,
  Typography,
  Space,
  Row,
  Col,
  Menu,
  Dropdown,
  message,
} from "antd";

import {
  CheckSquareOutlined,
  CloseSquareOutlined,
  DownOutlined,
  ExportOutlined,
  LeftOutlined,
  MoreOutlined,
  PrinterOutlined,
  RightOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "../Pages/CSS/Traitement.css";
import { TraitementService } from "../Services/TraitementService";
import { InterroComptaService } from "../Services/InterroComptaService";
import dayjs from "dayjs";
import { printComptService, printParticipComptService } from "../Services/PrintParticipComptService";
import * as XLSX from "xlsx";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;
const getSelectedYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear.toString();
};
const ParticipCompte = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [exercices, setExercices] = useState([]);
  const [societes, setSocietes] = useState([]);
  const [refetch, setRefetch] = useState(null);
  /*  const [dateDeb, setDateDeb] = useState(
     new Date(parseInt(selectedYear), 0, 1)
   );
   const [dateFin, setDateFin] = useState(
     new Date(parseInt(selectedYear), 11, 31)
   ); */
  const [dateDeb, setDateDeb] = useState(null);
  const [dateFin, setDateFin] = useState(null);

  const [selectEcriture, setSelectEcriture] = useState("ALL");
  const [selectedSociete, setSelectedSociete] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [adherents, setAdherents] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalSolde, setTotalSolde] = useState(0);
  const [soldeSelection, setSoldeSelection] = useState(0);
  const [selectedAdherent, setSelectedAdherent] = useState(null);
  const traitementFactureService = new TraitementService();
  const interroService = new InterroComptaService();

  useEffect(() => {
    const fetchSocietes = async () => {
      try {
        const societesData = await interroService.getAllSocietes();
        setSocietes(societesData);

        // Une fois que les sociétés sont chargées, définissez `selectedSociete`
        if (societesData.length > 0) {
          // Si aucune société n'est encore sélectionnée, définissez la première
          if (!selectedSociete) {
            setSelectedSociete(societesData[0].codeadht);
          }
        } else {
          // Si aucune société n'est trouvée, assurez-vous que `selectedSociete` soit bien null
          setSelectedSociete(null);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des sociétés :", error);
      }
    };

    const fetchExercices = async () => {
      try {
        const data = await traitementFactureService.getExercices();
        setExercices(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error);
      }
    };
    const fetchDefaultDates = async () => {
      try {
        const paramData = await traitementFactureService.getParamComptable();
        const yearFromParamData = dayjs(paramData.datedeb).format("YYYY");
        setSelectedYear(yearFromParamData)
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des dates par défaut :",
          error
        );
      }
    };

    fetchDefaultDates();
    fetchSocietes();
    fetchExercices();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      setDateDeb(new Date(parseInt(selectedYear), 0, 1));
      setDateFin(new Date(parseInt(selectedYear), 11, 31));
    }
  }, [selectedYear]);


  /* const handleSocieteChange = async (value) => {
    setSelectedSociete(value);
    try {
      const adherentsData = await interroService.getadherent(value);
      setAdherents(adherentsData);
      if (adherentsData.length > 0) {
        setSelectedAdherent(adherentsData[0].comptetiers);
      } else {
        setSelectedAdherent(null);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
      setSelectedAdherent(null);
    }
  }; */
  useEffect(() => {
    if (selectedSociete) {
      const fetchAdherents = async () => {
        try {
          const adherentsData = await interroService.getadherent(selectedSociete);
          setAdherents(adherentsData);

          if (adherentsData.length > 0) {
            setSelectedAdherent(adherentsData[0].comptetiers);
          } else {
            setSelectedAdherent(null);
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des adhérents :", error);
          message.error(
            "Une erreur est survenue lors de la récupération des adhérents."
          );
        }
      };

      fetchAdherents();
    }
  }, [selectedSociete]);

  const handleSocieteChange = async (value) => {
    setSelectedSociete(value);
  };
  useEffect(() => {
    if (!selectedAdherent) return;
    const fetchListAllParticipant = async () => {
      try {
        const participData = await interroService.getAllListParticipant(
          selectedAdherent,
          dateDeb,
          dateFin
        );
        setTableData(participData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des participants :",
          error
        );
      }
    };

    fetchListAllParticipant();
  }, [refetch, selectedAdherent, dateDeb, dateFin]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
    console.log(value);
    setDateDeb(new Date(value, 0, 1));
    setDateFin(new Date(value, 11, 31));
    setRefetch(Date.now());
    console.log(dateDeb);
  };

  const handlePrint = async () => {
    try {
      const formattedDateDeb = dayjs(dateDeb).format("YYYY-MM-DD");
      const formattedDateFin = dayjs(dateFin).format("YYYY-MM-DD");
      printParticipComptService(
        selectedAdherent,
        selectedYear,
        formattedDateDeb,
        formattedDateFin
      ); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    }
  };

  const handlePrintAll = async () => {
    try {
      const formattedDateDeb = dayjs(dateDeb).format("YYYY-MM-DD");
      const formattedDateFin = dayjs(dateFin).format("YYYY-MM-DD");
      printComptService(
        selectedSociete,
        selectedYear,
        formattedDateDeb,
        formattedDateFin
      ); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    }
  };

  const onSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };
  /* const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }; */


  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange, // Utilisation de la fonction nommée

    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = tableData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],

    getCheckboxProps: (record) => ({
      name: record.numligne,
    }),
  };

  const isButtonDisabled = selectedRowKeys.length === 0;

  useEffect(() => {
    const newTotalDebit = tableData.reduce(
      (sum, record) => sum + (record.debit || 0),
      0
    );
    const newTotalCredit = tableData.reduce(
      (sum, record) => sum + (record.credit || 0),
      0
    );
    const newSoldes = newTotalDebit - newTotalCredit;
    setTotalSolde(newSoldes);
    setTotalDebit(newTotalDebit);
    setTotalCredit(newTotalCredit);
  }, [tableData]);

  function formatNumber(number) {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  }

  const gestionMenu1 = (
    <Menu>
      <Menu.Item
        key="1"

        onClick={handlePrint}
      >
        Participant Courant
      </Menu.Item>
      <Menu.Item
        key="2"

        onClick={handlePrintAll}
      >
        Tous les Participants
      </Menu.Item>


    </Menu>
  );

  const handleMenuClick = async (e) => {
    // Extraire les lignes sélectionnées du tableau de données complet
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );

    // Si l'utilisateur a sélectionné "Lettrer"
    if (e.key === "Oui") {
      const totalDebit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.debit) || 0),
        0
      );
      const totalCredit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.credit) || 0),
        0
      );

      // Vérification de si la somme des débits et crédits est égale à zéro
      if (totalDebit !== totalCredit) {
        message.warning("Le solde lettrage n'est pas égal à 0!");
        return;
      }
    }

    try {
      const newLettrage = selectedRows.map((row) => ({
        ...row,
        lettrage: e.key,
      }));

      const response = await interroService.getLettrage(newLettrage);
      message.success("Lettrage effectué avec succès.");
      setRefetch(Date.now()); // Raffraîchir les données si nécessaire
    } catch (error) {
      message.error("Erreur lors du lettrage : " + error.message);
    }
  };

  const columns = [
    {
      title: "C.J.L",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.codej || "";
        const valueB = b.codej || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          tableData.map((item) => item?.codej).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.codej === value,
    },
    {
      title: "Date Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            placeholder="Rechercher une date"
            value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null}
            format="DD/MM/YYYY"
            onChange={(date) => {
              if (date) {
                setSelectedKeys([date.format("YYYY-MM-DD")]);
              } else {
                setSelectedKeys([]);
              }
            }}
            style={{ marginBottom: 8, width: "100%" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Réinitialiser
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Rechercher
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        const recordDate = moment(record.datecompta).format("YYYY-MM-DD");
        return recordDate === value;
      },
      render: (text) => moment(text).format("DD MMM YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datecompta).getTime();
        const valueB = new Date(b.datecompta).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            picker="month"
            placeholder="Rechercher un mois"
            value={selectedKeys[0] ? dayjs(selectedKeys[0], "YYYY-MM") : null}
            format="MMM YYYY"
            disabledDate={(current) => current && current > dayjs().endOf('day')}
            onChange={(date) => {
              if (date) {
                setSelectedKeys([date.format("YYYY-MM")]);
              } else {
                setSelectedKeys([]);
              }
            }}
            style={{ marginBottom: 8, width: "100%" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Réinitialiser
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Rechercher
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        const recordMonth = moment(record.datetrait).format("YYYY-MM");
        return recordMonth === value;
      },
      render: (text) => moment(text).format("MMM YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datetrait).getTime();
        const valueB = new Date(b.datetrait).getTime();
        return valueA - valueB;
      },
    },

    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.numpiece || "";
        const valueB = b.numpiece || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "N° Fact.",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.numfactipm || "";
        const valueB = b.numfactipm || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      ///sorter: (a, b) => a.comptegen.localeCompare(b.comptegen),
      sorter: (a, b) => {
        const valueA = a.comptegen || "";
        const valueB = b.comptegen || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      // sorter: (a, b) => a.comptetiers.localeCompare(b.comptetiers),
      sorter: (a, b) => {
        const valueA = a.comptetiers || "";
        const valueB = b.comptetiers || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => {
        const valueA = a.libelle || "";
        const valueB = b.libelle || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Lettrage",
      dataIndex: "lettrage",
      key: "lettrage",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.lettrage || "";
        const valueB = b.lettrage || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Débit
        </div>
      ),
      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {text && parseFloat(text) !== 0
              ? formatNumber(parseFloat(text))
              : ""}
          </strong>
        </div>
      ),
      sorter: (a, b) => parseFloat(a.debit || 0) - parseFloat(b.debit || 0),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Crédit
        </div>
      ),
      dataIndex: "credit",
      key: "credit",
      align: "right",
      fixed: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {text && parseFloat(text) !== 0
              ? formatNumber(parseFloat(text))
              : ""}
          </strong>
        </div>
      ),
      sorter: (a, b) => parseFloat(a.credit || 0) - parseFloat(b.credit || 0),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Frais Réels
        </div>
      ),
      dataIndex: "freels",
      key: "freels",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {text && parseFloat(text) !== 0
              ? formatNumber(parseFloat(text))
              : ""}
          </strong>
        </div>
      ),
      sorter: (a, b) => parseFloat(a.freels || 0) - parseFloat(b.freels || 0),
    },
  ];

  const onchangeEcriture = (value) => {
    setSelectEcriture(value);
  };

  // Fonction pour filtrer les données en fonction du lettrage
  const getFilteredData = () => {
    switch (selectEcriture) {
      case "Non":
        return tableData.filter((data) => data.lettrage);
      case "Oui":
        return tableData.filter((data) => !data.lettrage);
      case "ALL":
      default:
        return tableData;
    }
  };
  const lettrageMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="Oui">Lettrer</Menu.Item>
      <Menu.Item key="Non">Délettrer</Menu.Item>
    </Menu>
  );
  useEffect(() => {
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    const totalDebit = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.debit || 0),
      0
    );
    const totalCredit = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.credit || 0),
      0
    );

    const newSoldeSelection = totalDebit - totalCredit;
    setSoldeSelection(newSoldeSelection);
  }, [selectedRowKeys, tableData]); // Re-calcul à chaque changement de selectedRowKeys ou tableData

  const exportToExcel = (
    /*  let comptetiers,
   selectedAdhts = selectedAdherent.find(
      (med) => med.codeacte === codeacte
    ), */
    data,
    fileName = `compte ${selectedAdherent.comptetiers} ${selectedAdherent.participant}.xlsx`
  ) => {
    // Création d'un nouveau classeur
    const workbook = XLSX.utils.book_new();
    // Conversion des données en feuille de travail
    const worksheet = XLSX.utils.json_to_sheet(data);
    // Ajout de la feuille de travail au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Exportation du classeur (cela déclenchera le téléchargement)
    XLSX.writeFile(workbook, fileName);
  };

  const handlePreviousAdherent = () => {
    const currentIndex = adherents.findIndex(
      (adherent) => adherent.comptetiers === selectedAdherent
    );
    if (currentIndex > 0) {
      const previousAdherent = adherents[currentIndex - 1];
      setSelectedAdherent(previousAdherent.comptetiers);
    }
  };

  // Fonction pour gérer la navigation vers le fournisseur suivant
  const handleNextAdherent = () => {
    const currentIndex = adherents.findIndex(
      (adherent) => adherent.comptetiers === selectedAdherent
    );
    if (currentIndex < adherents.length - 1) {
      const nextAdherent = adherents[currentIndex + 1];
      setSelectedAdherent(nextAdherent.comptetiers);
    }
  };

  return (
    <div className="particip-compte-container">
      <Row gutter={16} style={{ marginBottom: "30px" }}>
        <Col>
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Text>Adhérents</Text>
            <Select
              onChange={handleSocieteChange}
              value={selectedSociete}
              style={{ width: 350 }}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {societes.map((societe) => (
                <Option key={societe.codeadht} value={societe.codeadht}>
                  {`${societe.codeadht} - ${societe.intitule}`}
                </Option>
              ))}
            </Select>
          </Space>
        </Col>
        <Col>
          {/*  <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Text>Adhérents</Text>
            <Select
              value={selectedAdherent}
              onChange={setSelectedAdherent}
              style={{ width: 350 }}
              showSearch
            >
              {adherents.map((adherent) => (
                <Option key={adherent.comptetiers} value={adherent.comptetiers}>
                  {adherent.comptetiers} - {adherent.participant}
                </Option>
              ))}
            </Select>
          </Space> */}

          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Text>Participants</Text>
            <Space>
              <Button
                className="Buttonvalid"
                icon={<LeftOutlined />}
                onClick={handlePreviousAdherent}
                disabled={
                  adherents.findIndex(
                    (adherent) => adherent.comptetiers === selectedAdherent
                  ) === 0
                } // Désactive le bouton si c'est le premier élément
              />
              <Select
                value={selectedAdherent}
                onChange={setSelectedAdherent}
                style={{ width: 350 }}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {adherents.map((adherent) => (
                  <Option
                    key={adherent.comptetiers}
                    value={adherent.comptetiers}
                  >
                    {`${adherent.comptetiers} - ${adherent.participant}`}
                  </Option>
                ))}
              </Select>
              <Button
                className="Buttonvalid"
                icon={<RightOutlined />}
                onClick={handleNextAdherent}
                disabled={
                  adherents.findIndex(
                    (adherent) => adherent.comptetiers === selectedAdherent
                  ) ===
                  adherents.length - 1
                } // Désactive le bouton si c'est le dernier élément
              />
            </Space>
          </Space>
        </Col>
      </Row>
      <Row
        gutter={16}
        justify="space-between"
        align="middle"
        style={{ marginBottom: "16px" }}
      >
        <Col
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "start",
          }}
        >
          <Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Exercice</label>
              <Select
                bordered={false}
                style={{
                  width: 90,
                  marginRight: 10,
                  borderBottom: "1px solid #030303",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {exercices.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Période</label>

              <RangePicker
                format="DD/MM/YYYY"
                value={[dayjs(dateDeb), dayjs(dateFin)]}
                onChange={(dates) => {
                  if (dates && dates.length === 2) {
                    setDateDeb(dates[0].toDate());
                    setDateFin(dates[1].toDate());
                    setRefetch(Date.now()); // Utiliser setRefetch pour forcer un rechargement des données
                  }
                }}
              />
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label style={{ marginBottom: "30px" }}>Type d'écriture</label>
              <Select
                bordered={false}
                style={{
                  width: 180,
                  marginRight: 10,
                  borderBottom: "1px solid #030303",
                }}
                defaultValue={selectEcriture}
                onChange={onchangeEcriture}
              >
                <Select.Option value="ALL">Toutes les écritures</Select.Option>
                <Option value="Non"> Écritures Non Léttrées</Option>
                <Option value="Oui"> Écritures Léttrées </Option>
              </Select>
            </Space>
          </Space>
        </Col>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <Space>
            <Button
              onClick={() => exportToExcel(getFilteredData())}
              className="buttonExport"
              icon={<ExportOutlined />}
              disabled={tableData.length === 0}
            >
              Export Excel
            </Button>

            <Dropdown disabled={isButtonDisabled} overlay={lettrageMenu}>
              <Button>
                Lettrage <DownOutlined />
              </Button>
            </Dropdown>
            {/* <Button
              className="buttonImprim"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              disabled={tableData.length === 0}
            >
              Imprimer Extrait
            </Button> */}
            <Dropdown
              disabled={tableData.length === 0}
              overlay={gestionMenu1}
              trigger={["click"]}
            >
              <Button className="buttonImprim" icon={<PrinterOutlined />}>
                Imprimer Extrait
                <MoreOutlined />
              </Button>
            </Dropdown>
          </Space>
        </Col>
      </Row>

      <Table
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header2-table my-custom-table"
        rowClassName={(record) =>
          selectedRowKeys.includes(record.numligne) ? "selected-row" : ""
        }
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        bordered
        rowSelection={rowSelection}
        columns={columns}
        showSorterTooltip={false}
        rowKey="numligne"
        dataSource={tableData.filter((data) => {
          if (selectEcriture === "Non") return data.lettrage === "Non";
          if (selectEcriture === "Oui") return data.lettrage === "Oui";
          return true;
        })}
        title={() => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Space>
              <strong>Total Débit: {formatNumber(totalDebit)}</strong> -
              <strong>Total Crédit: {formatNumber(totalCredit)}</strong> - (
              <strong style={{ color: "#4DBD74" }}>
                Soldes : {formatNumber(totalSolde)}
              </strong>
              )
            </Space>
            <Space>
              <strong>Solde de la sélection:</strong>
              <b style={{ color: "#4DBD74" }}>
                {soldeSelection.toLocaleString()}
              </b>
            </Space>
          </div>
        )}
      />
    </div>
  );
};

export default ParticipCompte;
